import { render } from "./ItemModifierSetTable.vue?vue&type=template&id=00de1a3c"
import script from "./ItemModifierSetTable.vue?vue&type=script&lang=js"
export * from "./ItemModifierSetTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__